export default [
    {
        path: "document-orders",
        name: "operations-document-orders",
        redirect: { name: "operations-document-orders-list" },
        component: () => import("@/views/operations/views/document-orders/DocumentOrders.vue"),
        meta: {
            section: 23,
            breadcrumb: [
                {
                    text: "Document Orders",
                    active: true,
                },
            ],
            tabs: [
                {
                    title: "Documents",
                    name: "operations-document-orders-list",
                }
            ],
        },
        children: [
            {
                path: "list",
                name: "operations-document-orders-list",
                component: () =>
                    import("@/views/operations/views/document-orders/components/DocumentOrderGrid.vue"),
                meta: {
                    section: 23,
                    pageTitle: "Document Orders",
                    breadcrumb: [
                        {
                            text: "Documents",
                        },
                    ],
                },
            },
        ]
    }
];